var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$isFlag
        ? _c("common-navbar", { attrs: { "is-home-bar": true } })
        : _vm._e(),
      _vm.loading
        ? _c(
            "van-loading",
            {
              staticClass: "jumpClass",
              attrs: {
                size: "40px",
                vertical: "",
                color: "#0094ff",
                "text-size": "17px"
              }
            },
            [_vm._v("正在跳转至支付宝")]
          )
        : _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFace == 1,
                    expression: "isFace == 1"
                  }
                ],
                staticClass: "appealResult"
              },
              [
                _c("img", {
                  attrs: {
                    src: require("assets/images/accountCenter/success@2x.png"),
                    alt: ""
                  }
                }),
                _c("p", [_vm._v("申诉成功")])
              ]
            ),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFace == 0,
                    expression: "isFace == 0"
                  }
                ],
                staticClass: "notice"
              },
              [_vm._v(_vm._s(_vm.noticeMsg))]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFace == 2,
                    expression: "isFace == 2"
                  }
                ],
                staticClass: "appealResult"
              },
              [
                _c("img", {
                  attrs: {
                    src: require("assets/images/accountCenter/fail@2x.png"),
                    alt: ""
                  }
                }),
                _c("p", [_vm._v("人脸认证失败")]),
                _c(
                  "div",
                  { staticClass: "btn" },
                  [
                    _vm.isShowAppealInfo
                      ? _c(
                          "van-button",
                          {
                            staticClass: "formClass_btn",
                            attrs: {
                              round: "",
                              plain: "",
                              type: "info",
                              color: "#616edf"
                            },
                            on: { click: _vm.handleWrite }
                          },
                          [_vm._v("手动填写申诉信息")]
                        )
                      : _vm._e(),
                    _c(
                      "van-button",
                      {
                        staticClass: "formClass_btn",
                        attrs: {
                          round: "",
                          block: "",
                          type: "info",
                          color: "#616edf",
                          disabled: _vm.disabled
                        },
                        on: { click: _vm.faceAgain }
                      },
                      [_vm._v("继续人脸申诉")]
                    )
                  ],
                  1
                )
              ]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }